// src/components/CarContattiForm.jsx
import React, { useState } from "react";
import useFormSubmit from "../../utilis/hook/useFormSubmit";
import { fetchListComuni } from "../../utilis/apiService";  //get
import { postPuntiVedndita } from "../../utilis/apiSend";  //post

const CarContattiForm = ({ isMobile }) => {
  const {
    formData,
    handleChange,
    handleSubmit,
    sending,
    resultMessage,
  } = useFormSubmit("react-endpoint-api/send-contatti", "contatti");

  const [comuni, setComuni] = useState([]);
  const [pvSedi, setPvSedi] = useState([]);

  // Quando cambio motivazione
  const onMotivazioneChange = (e) => {
    const val = e.target.value;
    handleChange(e);


    if (val === "Problema in un punto vendita" || val === 'Richiesta inserimento di prodotti o servizi') {
      fetchListComuni()
        .then((raw) => {
          // Se raw non è array, prendo i suoi valori in array
          const list = Array.isArray(raw)
            ? raw
            : Array.isArray(raw.data)
              ? raw.data
              : Object.values(raw)
          setComuni(list);
        })
        .catch((err) => {
          console.error("Errore fetch comuni:", err);
          setComuni([]);
        });
    } else if (val === "candidatura") {
      window.open(
        "https://www.carellijob.it/candidatura-spontanea.html",
        "_blank"
      );
    } else if (val === "Diventa un nostro fornitore") {
      window.open(
        "/diventa-partner#form",
        "_self"
      );
    } 
    else {
      // resetto se cambio scelta
      setComuni([]);
      setPvSedi([]);
    }
  };


  // Quando cambio comune
const onComuneChange = async (e) => {
    const codice = e.target.value;
    // aggiorno formData
    handleChange({ target: { name: "comune", value: codice } });

    if (!codice) {
      setPvSedi([]);
      return;
    }

    try {
      const raw = await postPuntiVedndita(codice);
      // trasformo raw in array di sedi
      let list = [];
      if (Array.isArray(raw)) {
        list = raw;
      } else if (Array.isArray(raw.data)) {
        list = raw.data;
      } else if (typeof raw === "object") {
        list = Object.values(raw);
      }
      setPvSedi(list);
    } catch (err) {
      console.error("Errore fetch sedi:", err);
      setPvSedi([]);
    }
  };


  return (
    <form onSubmit={handleSubmit} className="row g-3">
      {/* 1) Motivazione */}
      <div className="col-12">
        <select
          name="motivazione"
          className="form-select"
          required
          value={formData.motivazione || ""}
          onChange={onMotivazioneChange}
        >
          <option value="">Per quale motivo ci stai contattando</option>
          <option value="candidatura">Candidatura</option>
          <option value="Problema in un punto vendita">Problema in un punto vendita</option>
          <option value="Diventa un nostro fornitore">Diventa un nostro fornitore</option>
          <option value="Richiesta inserimento di prodotti o servizi">Richiesta inserimento di prodotti o servizi</option>
          <option value="Altro">Altro</option>
        </select>
      </div>

      {/* 2) Se Problema, mostro Comuni */}
      {(formData.motivazione === "Problema in un punto vendita"  || formData.motivazione === "Richiesta inserimento di prodotti o servizi" ) && (
        <div className="col-12">
          <select
            name="comune"
            className="form-select"
            required
            value={formData.comune || ""}
            onChange={onComuneChange}
          >
            <option value="">Seleziona Comune</option>
            {comuni.map((c) => (
              <option key={c} value={c}>
                {c.charAt(0).toUpperCase() + c.slice(1).toLowerCase()}
              </option>
            ))}
          </select>
        </div>
      )}

      {/* 3) Se ho un comune, mostro le sedi */}
      {formData.comune  && (
        <div className="col-12">
          <select
            name="sede"
            className="form-select"
            required
            value={formData.sede || ""}
            onChange={handleChange}
          >
            <option value="">Seleziona Punto Vendita</option>
            {pvSedi.map((pv) => (
              
              <option key={pv.codice} value={ pv.name + ' - ' + pv.address}>
                {pv.address} - {pv.postalCode}
              </option>
            ))}
          </select>
        </div>
      )}

      {/* 4) Nome */}
      <div className="col-12 col-md-6">
        <input
          type="text"
          name="nome"
          className="form-control"
          placeholder="Nome*"
          required
          value={formData.nome || ""}
          onChange={handleChange}
        />
      </div>

      {/* 5) Cognome */}
      <div className="col-12 col-md-6">
        <input
          type="text"
          name="cognome"
          className="form-control"
          placeholder="Cognome*"
          required
          value={formData.cognome || ""}
          onChange={handleChange}
        />
      </div>

      {/* 6) Email */}
      <div className="col-12">
        <input
          type="email"
          name="email"
          className="form-control"
          placeholder="Email*"
          required
          value={formData.email || ""}
          onChange={handleChange}
        />
      </div>

      {/* 7) Telefono */}
      <div className="col-12">
        <div className="input-group">
          <input
            type="tel"
            name="telefono"
            className="form-control"
            placeholder="Telefono*"
            required
            value={formData.telefono || ""}
            onChange={handleChange}
          />
          <span className="input-group-text">
            <i className="icon icon-tel" aria-hidden="true" />
          </span>
        </div>
      </div>

      {/* 8) Messaggio */}
      <div className="col-12">
        <textarea
          name="messaggio"
          className="form-control"
          placeholder="Come possiamo aiutarti"
          rows={4}
          required
          value={formData.messaggio || ""}
          onChange={handleChange}
        />
      </div>

      {/* 9) Privacy */}
      <div className="col-12">
        <div className="form-check">
          <input
            type="checkbox"
            name="privacy"
            id="privacy"
            className="form-check-input"
            value="Accettata"
            checked={formData.privacy === "Accettata"}
            onChange={(e) =>
              handleChange({
                target: {
                  name: "privacy",
                  value: e.target.checked ? "Accettata" : "",
                },
              })
            }
            required
          />
          <label className="form-check-label" htmlFor="privacy">

            Contattandoci tramite questo form, i dati personali da lei inviati verranno trattati da Carelli Distribuzione S.R.L. in veste di proprietario del "Titolare del Trattamento dei Dati" in base all'informativa sulla privacy riportata al seguente link
            {" "}
            <a href="/privacy-policy" target="_blank" rel="noreferrer">
              seguente link
            </a>
            *
          </label>
        </div>
      </div>

      {/* 10) Pulsante Invio */}
      <div className="col-12 d-flex justify-content-center">
        <button
          type="submit"
          className={`btn btn-sm btn-three ${isMobile ? "w-100" : ""}`}
          disabled={sending}
        >
          {sending ? "Invio..." : "Invia Messaggio"}
        </button>
      </div>

      {/* 11) Messaggio di feedback */}
      {resultMessage && (
        <div
          className={`alert ${resultMessage.type === "success"
              ? "alert-success"
              : "alert-danger"
            } mt-3 col-12`}
        >
          {resultMessage.text}
        </div>
      )}
    </form>
  );
};

export default CarContattiForm;
